module.exports = __webpack_public_path__ + "img/dots_mobile.7e99f18e.png";